module.exports = [
  {
    path: '/main/index/:pagetime?',
    pattern: /^\/main\/index(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/index.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/index.component.js'], function (require) {
            resolve(require('pages/main/index.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/wode/:pagetime?',
    pattern: /^\/main\/wode(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/wode.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/wode.component.js'], function (require) {
            resolve(require('pages/main/wode.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/quanxian_gl/:pagetime?',
    pattern: /^\/main\/huizong\/quanxian_gl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/quanxian_gl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/quanxian_gl.component.js'], function (require) {
            resolve(require('pages/main/huizong/quanxian_gl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/caozuo_xx/:pagetime?',
    pattern: /^\/main\/huizong\/caozuo_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/caozuo_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/caozuo_xx.component.js'], function (require) {
            resolve(require('pages/main/huizong/caozuo_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/weiquan_zj/:pagetime?',
    pattern: /^\/main\/cibao\/weiquan_zj(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/weiquan_zj.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/weiquan_zj.component.js'], function (require) {
            resolve(require('pages/main/cibao/weiquan_zj.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/goutong_hf/:pagetime?',
    pattern: /^\/main\/guanli\/goutong_hf(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/goutong_hf.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/goutong_hf.component.js'], function (require) {
            resolve(require('pages/main/guanli/goutong_hf.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/suzhuang_gl/:pagetime?',
    pattern: /^\/main\/huizong\/suzhuang_gl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/suzhuang_gl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/suzhuang_gl.component.js'], function (require) {
            resolve(require('pages/main/huizong/suzhuang_gl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/login/:pagetime?',
    pattern: /^\/main\/userDialog\/login(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/login.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/login.component.js'], function (require) {
            resolve(require('pages/main/userDialog/login.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/jingying_gl/:pagetime?',
    pattern: /^\/main\/guanli\/jingying_gl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/jingying_gl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/jingying_gl.component.js'], function (require) {
            resolve(require('pages/main/guanli/jingying_gl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/benji_dl/:pagetime?',
    pattern: /^\/main\/cibao\/benji_dl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/benji_dl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/benji_dl.component.js'], function (require) {
            resolve(require('pages/main/cibao/benji_dl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/tijiao_y/:pagetime?',
    pattern: /^\/main\/tijiao_y(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/tijiao_y.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/tijiao_y.component.js'], function (require) {
            resolve(require('pages/main/tijiao_y.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/authorize/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/authorize(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/authorize.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/authorize.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/authorize.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/suzhuang_sc/:pagetime?',
    pattern: /^\/main\/guanli\/suzhuang_sc(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/suzhuang_sc.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/suzhuang_sc.component.js'], function (require) {
            resolve(require('pages/main/guanli/suzhuang_sc.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/fapiao_gl/:pagetime?',
    pattern: /^\/main\/huizong\/fapiao_gl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/fapiao_gl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/fapiao_gl.component.js'], function (require) {
            resolve(require('pages/main/huizong/fapiao_gl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/changePassword/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/changePassword(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/changePassword.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/changePassword.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/changePassword.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/forgetPassword/:pagetime?',
    pattern: /^\/main\/userDialog\/forgetPassword(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/forgetPassword.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/forgetPassword.component.js'], function (require) {
            resolve(require('pages/main/userDialog/forgetPassword.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/register/:pagetime?',
    pattern: /^\/main\/userDialog\/register(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/register.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/register.component.js'], function (require) {
            resolve(require('pages/main/userDialog/register.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/suxin_tx/:pagetime?',
    pattern: /^\/main\/cibao\/suxin_tx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/suxin_tx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/suxin_tx.component.js'], function (require) {
            resolve(require('pages/main/cibao/suxin_tx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/authorize/:pagetime?',
    pattern: /^\/main\/userDialog\/authorize(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/authorize.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/authorize.component.js'], function (require) {
            resolve(require('pages/main/userDialog/authorize.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/yonghu_xy/:pagetime?',
    pattern: /^\/main\/cibao\/yonghu_xy(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/yonghu_xy.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/yonghu_xy.component.js'], function (require) {
            resolve(require('pages/main/cibao/yonghu_xy.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/user/:pagetime?',
    pattern: /^\/main\/userDialog\/user(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/user.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/user.component.js'], function (require) {
            resolve(require('pages/main/userDialog/user.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/yiyi_xq/:pagetime?',
    pattern: /^\/main\/cibao\/yiyi_xq(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/yiyi_xq.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/yiyi_xq.component.js'], function (require) {
            resolve(require('pages/main/cibao/yiyi_xq.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/weiquan_wg/:pagetime?',
    pattern: /^\/main\/cibao\/weiquan_wg(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/weiquan_wg.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/weiquan_wg.component.js'], function (require) {
            resolve(require('pages/main/cibao/weiquan_wg.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/register/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/register(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/register.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/register.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/register.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/wode_jy/:pagetime?',
    pattern: /^\/main\/wode_jy(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/wode_jy.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/wode_jy.component.js'], function (require) {
            resolve(require('pages/main/wode_jy.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/yewu_gl/:pagetime?',
    pattern: /^\/main\/huizong\/yewu_gl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/yewu_gl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/yewu_gl.component.js'], function (require) {
            resolve(require('pages/main/huizong/yewu_gl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/goutong_xx/:pagetime?',
    pattern: /^\/main\/huizong\/goutong_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/goutong_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/goutong_xx.component.js'], function (require) {
            resolve(require('pages/main/huizong/goutong_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/yewu_xq/:pagetime?',
    pattern: /^\/main\/huizong\/yewu_xq(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/yewu_xq.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/yewu_xq.component.js'], function (require) {
            resolve(require('pages/main/huizong/yewu_xq.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/login/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/login(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/login.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/login.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/login.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/yiyi_qr/:pagetime?',
    pattern: /^\/main\/guanli\/yiyi_qr(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/yiyi_qr.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/yiyi_qr.component.js'], function (require) {
            resolve(require('pages/main/guanli/yiyi_qr.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/jinyan_xx/:pagetime?',
    pattern: /^\/main\/huizong\/jinyan_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/jinyan_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/jinyan_xx.component.js'], function (require) {
            resolve(require('pages/main/huizong/jinyan_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/yonghu_xx/:pagetime?',
    pattern: /^\/main\/huizong\/yonghu_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/yonghu_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/yonghu_xx.component.js'], function (require) {
            resolve(require('pages/main/huizong/yonghu_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/yiyi_jy/:pagetime?',
    pattern: /^\/main\/yiyi_jy(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/yiyi_jy.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/yiyi_jy.component.js'], function (require) {
            resolve(require('pages/main/yiyi_jy.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/bindphone/:pagetime?',
    pattern: /^\/main\/userDialog\/bindphone(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/bindphone.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/bindphone.component.js'], function (require) {
            resolve(require('pages/main/userDialog/bindphone.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/user/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/user(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/user.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/user.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/user.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/suzhuang_xz/:pagetime?',
    pattern: /^\/main\/cibao\/suzhuang_xz(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/suzhuang_xz.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/suzhuang_xz.component.js'], function (require) {
            resolve(require('pages/main/cibao/suzhuang_xz.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/susong_xx/:pagetime?',
    pattern: /^\/main\/guanli\/susong_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/susong_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/susong_xx.component.js'], function (require) {
            resolve(require('pages/main/guanli/susong_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/fapiao_sc/:pagetime?',
    pattern: /^\/main\/guanli\/fapiao_sc(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/fapiao_sc.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/fapiao_sc.component.js'], function (require) {
            resolve(require('pages/main/guanli/fapiao_sc.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/weiquan_cy/:pagetime?',
    pattern: /^\/main\/cibao\/weiquan_cy(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/weiquan_cy.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/weiquan_cy.component.js'], function (require) {
            resolve(require('pages/main/cibao/weiquan_cy.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/puguang_ply/:pagetime?',
    pattern: /^\/main\/puguang_ply(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/puguang_ply.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/puguang_ply.component.js'], function (require) {
            resolve(require('pages/main/puguang_ply.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/weiquan_xx/:pagetime?',
    pattern: /^\/main\/huizong\/weiquan_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/weiquan_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/weiquan_xx.component.js'], function (require) {
            resolve(require('pages/main/huizong/weiquan_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/yijian_jy2/:pagetime?',
    pattern: /^\/main\/huizong\/yijian_jy2(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/yijian_jy2.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/yijian_jy2.component.js'], function (require) {
            resolve(require('pages/main/huizong/yijian_jy2.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/weiquan_sh/:pagetime?',
    pattern: /^\/main\/guanli\/weiquan_sh(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/weiquan_sh.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/weiquan_sh.component.js'], function (require) {
            resolve(require('pages/main/guanli/weiquan_sh.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/yiyi_tj/:pagetime?',
    pattern: /^\/main\/cibao\/yiyi_tj(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/yiyi_tj.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/yiyi_tj.component.js'], function (require) {
            resolve(require('pages/main/cibao/yiyi_tj.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/weiquan_zh/:pagetime?',
    pattern: /^\/main\/guanli\/weiquan_zh(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/weiquan_zh.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/weiquan_zh.component.js'], function (require) {
            resolve(require('pages/main/guanli/weiquan_zh.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/beiyong/:pagetime?',
    pattern: /^\/main\/huizong\/beiyong(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/beiyong.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/beiyong.component.js'], function (require) {
            resolve(require('pages/main/huizong/beiyong.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/falv_wq/:pagetime?',
    pattern: /^\/main\/cibao\/falv_wq(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/falv_wq.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/falv_wq.component.js'], function (require) {
            resolve(require('pages/main/cibao/falv_wq.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/bindphone/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/bindphone(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/bindphone.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/bindphone.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/bindphone.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/lianxi_wm/:pagetime?',
    pattern: /^\/main\/lianxi_wm(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/lianxi_wm.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/lianxi_wm.component.js'], function (require) {
            resolve(require('pages/main/lianxi_wm.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/userDialog/changePassword/:pagetime?',
    pattern: /^\/main\/userDialog\/changePassword(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/userDialog/changePassword.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/userDialog/changePassword.component.js'], function (require) {
            resolve(require('pages/main/userDialog/changePassword.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/yiyi_xx/:pagetime?',
    pattern: /^\/main\/huizong\/yiyi_xx(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/yiyi_xx.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/yiyi_xx.component.js'], function (require) {
            resolve(require('pages/main/huizong/yiyi_xx.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/susong_xx2/:pagetime?',
    pattern: /^\/main\/huizong\/susong_xx2(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/susong_xx2.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/susong_xx2.component.js'], function (require) {
            resolve(require('pages/main/huizong/susong_xx2.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/cibao/canyu_qr/:pagetime?',
    pattern: /^\/main\/cibao\/canyu_qr(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/cibao/canyu_qr.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/cibao/canyu_qr.component.js'], function (require) {
            resolve(require('pages/main/cibao/canyu_qr.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/jinyan_gl/:pagetime?',
    pattern: /^\/main\/guanli\/jinyan_gl(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/jinyan_gl.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/jinyan_gl.component.js'], function (require) {
            resolve(require('pages/main/guanli/jinyan_gl.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/huizong/weiquan_gz/:pagetime?',
    pattern: /^\/main\/huizong\/weiquan_gz(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/huizong/weiquan_gz.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/huizong/weiquan_gz.component.js'], function (require) {
            resolve(require('pages/main/huizong/weiquan_gz.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/wxsys/comps/user/userDialog/forgetPassword/:pagetime?',
    pattern: /^\/wxsys\/comps\/user\/userDialog\/forgetPassword(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/wxsys/comps/user/userDialog/forgetPassword.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/wxsys/comps/user/userDialog/forgetPassword.component.js'], function (require) {
            resolve(require('pages/wxsys/comps/user/userDialog/forgetPassword.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/jianyi_qr/:pagetime?',
    pattern: /^\/main\/guanli\/jianyi_qr(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/jianyi_qr.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/jianyi_qr.component.js'], function (require) {
            resolve(require('pages/main/guanli/jianyi_qr.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/guanli/weiquan_fh/:pagetime?',
    pattern: /^\/main\/guanli\/weiquan_fh(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/guanli/weiquan_fh.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/guanli/weiquan_fh.component.js'], function (require) {
            resolve(require('pages/main/guanli/weiquan_fh.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
  {
    path: '/main/wode_wq/:pagetime?',
    pattern: /^\/main\/wode_wq(?:\/((?:[^\/]+?)))?(?:\/(?=$))?$/i,
    keys: [{"name":"pagetime","prefix":"/","delimiter":"/","optional":true,"repeat":false,"partial":false,"asterisk":false,"pattern":"[^\\/]+?"}],
    page: 'pages/main/wode_wq.component.js',
    load() {
      return new Promise(function (resolve, reject) {
        try {
          require.ensure(['pages/main/wode_wq.component.js'], function (require) {
            resolve(require('pages/main/wode_wq.component.js').default);
          });
        } catch (err) {
          reject(err);
        }
      });
    },
  },
];


// WEBPACK FOOTER //
// ./routes.json